import type React from 'react'
import styles from '../SelfOnboarding.module.css'

interface MainPopupProps {
  teamDashboardLabel?: string
  teamSectionLabel?: string
  selectedMenu: number
  stepCompleted: number
  options: string[]
  onClose: () => void
  onMenuSelect: (idx: number) => void
  children?: React.ReactNode
  title?: string
  description?: string
}

const MainPopup: React.FC<MainPopupProps & {hideAllChrome?: boolean}> = ({
  selectedMenu,
  stepCompleted,
  options,
  onClose,
  onMenuSelect,
  children,
  title,
  description,
  hideAllChrome = false,
}) => {
  if (hideAllChrome) {
    return (
      <div className={styles.onboardingModalContent}>
        <div className={styles.mainPopupLayout}>
          <main className={styles.mainContent}>
            <div className={styles.mainContentColumn}>
              <div className={styles.contentContainer}>{children}</div>
            </div>
          </main>
        </div>
      </div>
    )
  }
  return (
    <div className={styles.onboardingModalContent}>
      <div className={styles.mainPopupLayout}>
        <aside className={styles.sidebar}>
          {options.map((opt, idx) => (
            <li
              key={opt}
              className={
                idx <= selectedMenu ? `${styles.sidebarItem} ${styles.sidebarItemCompleted}` : styles.sidebarItem
              }
            >
              <span
                className={
                  idx === selectedMenu
                    ? `${styles.menuItemText} ${styles.selected}`
                    : stepCompleted > idx
                      ? `${styles.menuItemText} ${styles.stepCompleted}`
                      : styles.menuItemText
                }
              >
                {opt}
              </span>
            </li>
          ))}
        </aside>
        <main className={styles.mainContent}>
          <div className={styles.mainContentColumn}>
            <div>
              <div className={styles.stepTitle}>{title}</div>
              <div className={styles.stepHeading}>{description}</div>
            </div>
            <div className={styles.contentContainer}>{children}</div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default MainPopup
